import { FormControl } from "@angular/forms";
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { AuthService } from "../../../../../services/auth.service";
import { IntercomService } from "../../../../../services/intercom.service";
import { TokenService } from "../../../../../services/token.service";
import { ProposalsService } from "../../../../../services/showroom/proposals.service";
import { Subscription, fromEvent, Observable } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { Proposal } from "./../../../../pages/showroom/proposals/proposal";
import { PrivateLabelService } from "../../../../pages/showroom/private-label.service";

@Component({
	selector: "m-user-profile",
	templateUrl: "./user-profile.component.html",
	styleUrls: ["./user-profile.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileComponent implements OnInit, AfterViewInit, OnDestroy {
	// @HostBinding('class')
	// tslint:disable-next-line:max-line-length
	// classes = 'm-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light';

	// @HostBinding('attr.m-dropdown-toggle') attrDropdownToggle = 'click';

	@Input() avatar: string = "./assets/app/media/img/users/placeholder-man.png";
	@Input() avatarBg: SafeStyle = "";

	// @ViewChild('mProfileDropdown') mProfileDropdown: ElementRef;

	public showDropdown: boolean = false;

	private _multiplier: boolean = true;

	private subscriptions: Subscription[] = [];

	@ViewChild("container") container: ElementRef;

	constructor(private router: Router, private authService: AuthService, public tokenService: TokenService, private sanitizer: DomSanitizer, private intercom: IntercomService, private proposal: Proposal, private privateLabelService: PrivateLabelService, private ref: ChangeDetectorRef) {}

	get isPrivateLabel$(): Observable<boolean> {
		return this.privateLabelService.isPrivateLabel$;
	}

	ngOnInit(): void {
		if (!this.avatarBg) {
			this.avatarBg = this.sanitizer.bypassSecurityTrustStyle("url(./assets/app/media/img/misc/user_profile_bg.jpg)");
		}
	}

	ngAfterViewInit() {
		let timeout: any;
		this.subscriptions.push(
			fromEvent(this.container.nativeElement, "mouseleave").subscribe((event) => {
				timeout = setTimeout(() => {
					this.showDropdown = false;
					this.detectChanges();
				}, 500);
			})
		);
		this.subscriptions.push(
			fromEvent(this.container.nativeElement, "mouseenter").subscribe((event) => {
				clearTimeout(timeout);
			})
		);
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	public toggleDropdown() {
		this.showDropdown = !this.showDropdown;
		this.detectChanges();
	}

	public isShowroomUser(): boolean {
		return this.tokenService.user.role == "sales" || this.tokenService.user.role == "showroom_admin";
	}

	public isVendorUser(): boolean {
		return this.tokenService.user.role == "vendor_user" || this.tokenService.user.role == "vendor_admin";
	}

	public navigateToMyProfile(urlPrefix: string) {
		this.showDropdown = false;
		this.router.navigateByUrl(`/${urlPrefix}/my-profile`);
	}

	public navigateToSubscriptionInfo(urlPrefix: string) {
		this.router.navigateByUrl(`/${urlPrefix}/pricing`);
	}

	public logout() {
		this.authService.getLogoutUrl().subscribe((url) => {
			this.authService.logout();
			this.intercom.close();
			this.router.navigateByUrl(url);
		});
	}

	public navigateToProductUpdates() {
		if (this.isVendorUser()) {
			this.router.navigateByUrl("/vendor/product-updates");
		} else {
			this.router.navigateByUrl("/showroom/product-updates");
		}
	}

	public toggleMultiplier(event: any) {
		this.proposal.multiplier$.next(event.checked);
	}

	private detectChanges(): void {
		try {
			this.ref.detectChanges();
		} catch (e) {
			//
		}
	}
}
